// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".preview-button-enter-active,.preview-button-leave-active{transition:transform .4s,opacity .4s}.preview-button-enter,.preview-button-leave-to{opacity:0}.preview-button-enter-active{transition-delay:1.2s}.preview-button-enter{transform:translateY(100%)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
